import { createContext } from 'react'

export type SsrContextType = {
  isMobileUA?: boolean
}

export const SsrContext = createContext<SsrContextType>({})
